/*******************************************************************************
EXPAND TOP OUTLOOK ON PLAYER PAGES
Expands the outlook at the top of the page to display the full text.
*******************************************************************************/

export default function expandPlayerOutlook() {
    $('.p-card__outlook-more').remove();
    $('.p-card__outlook').addClass('is-expanded');
    $('.p-card__stats').css('border-bottom', '1px solid #ddd');
}
